import { useState } from "react";

import { useStepContext } from "../../utils/StepContext.jsx";
import { useFormContext } from "../../utils/FormContext.jsx"; 
import { useMediaQuery } from "react-responsive";
import { useAuth } from "../../utils/AuthContext/AuthContext.jsx"

import MainCard from "../MainCard.jsx";
import ProgressBar from "../ProgressBar/ProgressBar.jsx";
import InfoModal from "../InfoModal.jsx";

import InfoSVG from "../../assets/InfoSVG.jsx";
import SaveButton from "../SaveButton.jsx";
import PDFPreview from "../PDFPreview.jsx";
import HelpButton from "../HelpButton.jsx";
import ShishitoAssist from "../ShishitoAssist/ShishitoAssist.jsx";

const AdditionalProvisions = () => {

    const { handleNext, handleBack, markStepAsComplete, unsetStepAsComplete } = useStepContext();
    const { formData, formId, handleProvisionsChange } = useFormContext(); 
    const [isInfoModalOpen, setIsInfoModalOpen] = useState(false); 
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const { user } = useAuth();
    const [isAssistVisible, setIsAssistVisible] = useState(false);
    
    const currentPageValue = 2;
    const currentSubStepProgress = 7/7; 

    const handleInfoClick = () => {
        setIsInfoModalOpen(true); 
    }; 

    const handleCloseInfoModal = () => {
        setIsInfoModalOpen(false); 
    }

    const onBack = () => {
        unsetStepAsComplete(currentPageValue);
        handleBack();
    };

    const onNext = () => {
            markStepAsComplete(currentPageValue); // Mark this step as complete
            handleNext(); // Navigate to the next step
    };

    const toggleAssist = () => {
        setIsAssistVisible(!isAssistVisible);
    };

    const InfoModalContent =
        {
        title: "What Are Additional Provisions",
        content: "Additonal Provisions are different stipulations you can put in your offer. For example a rate buydown.",
        // secondHeader: "Which Method Should I Choose?",
        // contentTwo: "Generally Speaking if there have been significant changes in the property's assessed value or the tax rate for the current year. You could use the taxes from the previous calendar year if the current year's property taxes have not been assessed yet or when there has been no significant change in the property's assessed value or the mill levy rate for the current year.",
        }; 

    // console.log(formData);

    return (
        <div className="w-full flex flex-col items-center">
        {/* <ProgressBar currentPage={currentPageValue} subStepProgress={currentSubStepProgress}/> */}
        <MainCard width={750}>
        <div className="overflow-y-auto md:max-h-[425px] max-h-[45vh] w-full">
            <div className="w-full inline-flex justify-between md:pr-6 items-center gap-6 mb-8">
                    <div className="flex flex-row gap-2 items-center">
                        <InfoSVG onClick={handleInfoClick} width={20} height={20}/>
                        {isMobile ? <h3 className="text-black text-[18px] text-left font-normal font-['Inter']">Provisions</h3> : <h3 className="text-black text-xl text-left font-normal font-['Inter']">Additional provisions</h3>}    
                    </div>
                    <div className='items-center gap-2 md:gap-4 inline-flex md:pl-0'>
                        <HelpButton onClick={toggleAssist}/>
                        <SaveButton formData={formData} formId={formId}/>
                        {user && <PDFPreview formData={formData}/>}
                    </div>
            </div>
            <div className="flex flex-col text-left justify-start gap-2 items-start w-full md:px-6">
            <div className="w-full mb-1 justify-start gap-2 items-start flex flex-col">
                <span className='text-[14px] md:text-sm text-slate-600'>
                    Additional Provisions - Other Transaction Specific Negotiations e.g. Rate Buydown
                </span>
            </div>
            <div className="w-full py-1 px-3 h-[39px] self-stretch text-left bg-white rounded-md border border-slate-300 justify-start items-center gap-2.5 flex">
            <input 
                type="text"
                name="additionalProvisions"
                placeholder="Add other Provisions Not Listed" 
                className="text-left pl-2 w-full" 
                value={formData.additionalProvisions}
                onChange={handleProvisionsChange}
                required
            />
            </div>    
            </div>
            </div>
            <div className="w-[320px] md:w-[456.79px] h-[41px] justify-between inline-flex">
                <button className="w-[100px] md:w-[150px] justify-center text-center text-shi-green bg-white border-white text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-slate-200 items-center flex" onClick={onBack}>
                    Back
                </button>
                <button className="w-[100px] md:w-[150px] justify-center text-center text-white bg-shi-green text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-green-950 items-center flex" onClick={onNext}>
                    Next
                </button>
            </div>
        </MainCard>
        {isAssistVisible && (
                <div className="w-full md:w-auto absolute bottom-1 md:right-4">
                    <ShishitoAssist onClose={toggleAssist}/>
                </div>
            )}

        <InfoModal isOpen={isInfoModalOpen} onClose={handleCloseInfoModal}>
                <div>
                    <h1 className="text-shi-green text-2xl font-bold mb-4">{InfoModalContent.title}</h1>
                    <hr className="my-4" />
                    <p className="text-base">{InfoModalContent.content}</p>
                    
                    {/* <h1 className="text-shi-green text-2xl font-bold my-4">{InfoModalContent.secondHeader}</h1>
                    <hr className="my-4" />
                    <p className="text-base">{InfoModalContent.contentTwo}</p> */}
                </div>
        </InfoModal>
        </div>
        
    )
}

export default AdditionalProvisions; 